<template>
  <div>
    <b-modal
      ref="lawEventFormModal"
      id="lawEventFormModal"
      centered
      size="lg"
      no-close-on-backdrop
      :title="$t('lawEvent.info')"
      :cancel-title="$t('others.cancel_title')"
      :ok-title="$t('others.ok_title')"
      cancel-variant="outline-secondary"
      @ok.prevent="addOrUpdate()">
      <validation-observer ref="simpleRules">
        <b-card>
            <b-row>
                <b-col class="col-lg-4"> 
                        <label>{{ $t('lawEvent.law_event_type_name') }}</label>
                         <validation-provider v-slot="{ errors }" :name=" $t('lawEvent.law_event_type_name')" :rules="{ excluded:0}" >
                        <b-form-group>
                            <b-form-select v-model="eventTypeSelect" value-field="id" text-field="name" size="sm" :options="eventTypeOptions" :state="errors.length > 0 ? false:null"/> 
                       </b-form-group>
                        <small class="text-danger">{{ errors[0] }}</small> 
                    </validation-provider>
					
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawEvent.date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" size="sm" v-model="date" class="mb1" defaultDate: null  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-no-date-selected="$t('dateTime.select_date')" />
                              
                        </b-form-group>
                    </b-form>
                </b-col>
                  <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('lawEvent.location') }}</label>
                        <b-form-group>
                            <b-form-input size="sm"  v-model="location" maxlength="100" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
               <b-col class="col-lg-12">
                        <b-form>
                             <label>{{ $t('lawEvent.note') }}</label>
                           <b-form-group>
                                <b-form-textarea :placeholder=" $t('lawEvent.note')" v-model="note" rows="3"  maxlength="250" />
                           </b-form-group>
                        </b-form>
                </b-col>
            </b-row>
          
        </b-card>
        </validation-observer>
    </b-modal>
  </div>
</template>

<script>
export default {
    data(){
        return {
            id:0,
            eventTypeOptions: [],
            eventTypeSelect: 0,
            date: new Date(),
            location: '',
            note: ''
        }
    },

    methods:{
        async showInfo(id){
            this.$refs['lawEventFormModal'].show()
            this.id = id
            const data = {  id: this.id}
              
            const controller = {  name: 'LawEvent' }
            const payload = { data: data,controller: controller}

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.eventTypeOptions = response.data.lawEventTypeList
                    this.eventTypeOptions.splice(0, 0, this.$nullSelected())
                    this.eventTypeSelect = response.data.lawEvent.eventTypeId
                    this.date = response.data.lawEvent.date
                    if(!this.id) this.date = new Date()
                    this.location = response.data.lawEvent.location
                    this.note = response.data.lawEvent.note
                   
                } else {
                    this.$bvModal.hide('lawEventFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
          
        },
        async addOrUpdate(){
            const lawEventData = {
                id: this.id,
                lawMatterMatterTypeHistoryId: this.matterTypeHistoryId,
                eventTypeId: this.eventTypeSelect,
                date :this.date,
                location: this.location,
                note:this.note
               
            };
             const controller = {name: 'LawEvent' }   
             const payload = {data: lawEventData,  controller: controller}
             const success = await this.$refs.simpleRules.validate()
             if(success){
                const response = await this.$store.dispatch('moduleAuth/save', payload)
                if (response.data.resultStatus) {
                    this.$bvModal.hide('lawEventFormModal')
                    this.getLawEventList()
                    this.$SaveAlert()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }   
             }
             
        }
    },
    props: {
        matterTypeHistoryId: {
            type: Number
        },
        getLawEventList:{
            type: Function
        }
    }
}

</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>